import { Component, input, signal } from "@angular/core";
import { LevelItemComponent } from "../../UI/level-item/level-item.component";
import { Curriclum } from "../../../models/ilanding";
import { Skeleton, SkeletonModule } from "primeng/skeleton";
import { log } from "console";
import { RouterLink } from "@angular/router";
import { MainBtnComponent } from "../../UI/main-btn/main-btn.component";

@Component({
  selector: "app-free-levels",
  standalone: true,
  imports: [LevelItemComponent, RouterLink , SkeletonModule, Skeleton, MainBtnComponent],
  templateUrl: "./free-levels.component.html",
  styleUrl: "./free-levels.component.css",
})
export class FreeLevelsComponent {
  loading = input<boolean>();
  isLoading = signal<boolean>(false);
  levels = input<Curriclum[] | undefined>();
  freeLevels = signal<Curriclum[] | null>(null);
  startIndex = signal<number>(0);
  endIndex = signal<number>(4);

  timing = setInterval(() => {
    if (this.levels()) {
      // this.getFreeLevels();
      this.freeLevels.set(this.levels()?.slice(this.startIndex(), this.endIndex()) ?? null);
      clearInterval(this.timing);
      return;
    }
  }, 500);

  // getFreeLevels() {
  //   this.isLoading.set(true);
  //   this.endIndex.set(this.endIndex() + 4);
  //   this.freeLevels.set(this.levels()?.slice(this.startIndex(), this.endIndex()) ?? null);
  //   setTimeout(() => {
  //     this.isLoading.set(false);
  //   }, 500);
  // }
}
